import { render, staticRenderFns } from "./EditReportPage.vue?vue&type=template&id=be3db2f0&scoped=true&"
import script from "./EditReportPage.vue?vue&type=script&lang=ts&"
export * from "./EditReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3db2f0",
  null
  
)

export default component.exports